<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <full-page-shell
    class="login-el-outer"
  >
    <customer-login
      class="login-component"
    ></customer-login>

    <vs-divider/>
    <div class="site-info display-flex justify-center">
      <span>COPYRIGHT &copy; {{ thisYear }} Maxain</span>
      <!--            {{config.siteName}}-->
    </div>
  </full-page-shell>
</template>

<script>
import customerLogin from '@/components/login/customerLogin'
import fullPageShell from "@/components/public/fullPageShell";

export default{
    components:{
      fullPageShell,
      customerLogin,
    },
  data() {
    return {
      step: 'first'
    }
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1200px) {
  .login-el-outer {
    .login-component {
      padding-top: 160px;
    }
  }
}

</style>
